import {z} from 'zod';

export const productSchema = z.object({
    name: z.string(),
    description: z.string(),
    image: z.string(),
    price: z.number(),
    quantity: z.number(),
    category: z.string(),
    acceptTerms: z.boolean(),
    privacy: z.boolean(),
    allowOffer: z.boolean(),
    promotionalPrice: z.number().optional().nullable().transform((v) => v || undefined),
});

/*
export const productSchema = z.object({
    name: z.string(),
    description: z.string(),
    image: z.string(),
    brand: z.string(),
    space: z.string(),
    solutions: z.string(),
    problems: z.string(),
    storeId: z.string(),
    price: z.number(),
    quantity: z.number(),
    category: z.string(),
});
*/